import { MapPin as MapPinIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function MapPlaceholder() {
	const { t } = useTranslation(["common"]);

	return (
		<div
			className="flex flex-col items-center justify-center w-full h-full min-h-[120px] md:min-h-[250px] border border-dashed border-gray-300 bg-gray-50 text-gray-400 px-4"
			data-testid="pharmacy-map-placeholder"
		>
			<MapPinIcon className="size-6 md:size-10 mb-2 md:mb-3 stroke-1" />
			<p className="text-body-small md:text-body text-gray-500 text-center">
				{t("pharmacyMap.placeholder.title")}
			</p>
		</div>
	);
}
